import { ref, type Ref } from 'vue';

interface ExpansionPanelsController {
  /**
   * Open section.
   */
  openSection: Ref<number>;

  /**
   * Toggle event handler that keeps one panel expanded only.
   *
   * @param index panel index
   * @param opened expanded (`true`) or collapsed (`false`)
   */
  toggle(index: number, opened: boolean): void;
}

/**
 * Provides the expansion panels controller.
 */
export function useExpansionPanelsController(): ExpansionPanelsController {
  const openSection = ref(-1);

  const toggle = (index: number, opened: boolean) => {
    openSection.value = opened ? index : -1;
  };

  return {
    openSection,
    toggle,
  };
}
